module.exports = __webpack_public_path__ + "static/media/compare_inactive.ab15ffda.svg";